import styled from 'styled-components';

const StyledImage = styled.span`
  overflow: hidden;
  width: ${({ size }) => `${size || '10px'}`};
  height: ${({ size }) => `${size || '10px'}`};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export default StyledImage;
